import { Component, computed, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IconComponent } from '@shared/components/icon/icon.component';

export interface ISnackbarData {
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
}

@Component({
  imports: [MatButtonModule, IconComponent],
  selector: 'app-snackbar',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center gap-3">
      <div class="rounded-full w-10 h-10 flex items-center justify-center">
        <img [src]="statusIcon()" [alt]="type()" class="w-10 h-10" />
      </div>
      <span class="flex-1">{{ message() }}</span>
      <button class="close-button" (click)="snackBarRef.dismiss()">
        <app-icon src="/icons/close.svg" alt="Close" class="w-5 h-5" />
      </button>
    </div>
  `,
})
export class SnackbarComponent {
  protected readonly snackBarRef = inject(MatSnackBarRef);

  protected readonly message = computed(() => this.snackbarData().message);
  protected readonly type = computed(() => this.snackbarData().type);
  protected readonly statusIcon = computed(() => {
    const iconMap: Record<ISnackbarData['type'], string> = {
      error: '/icons/snackbar/error.svg',
      info: '/icons/snackbar/info.svg',
      success: '/icons/snackbar/success.svg',
      warning: '/icons/snackbar/warning.svg',
    };

    return iconMap[this.type()];
  });

  private readonly snackbarData = signal<ISnackbarData>(inject(MAT_SNACK_BAR_DATA));
}
